"use client"

import { useLayoutEffect, useRef } from "react"

export function BackgroundBlurStyle() {
  const ref = useRef<HTMLStyleElement>(null)

  useLayoutEffect(() => {
    const tag = ref.current
    if (!tag) return

    tag.media = "all"

    return () => {
      tag.media = "not all"
    }
  }, [])

  return <style ref={ref}>{`:root { --background-blur: 0px; }`}</style>
}
